var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('el-scrollbar',{staticClass:"service-scroll"},[_c('div',{staticClass:"service-content"},[_c('IframeWeb',{ref:"iframe",attrs:{"url":_vm.iframeUrl}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }